import React from 'react';
import './SelectizeLookingDropdownArrow.styl';

const SelectizeLookingDropdownArrow = ({open, onShowDropdown}) => (
  <div className="selectize-looking-dropdown-arrow-wrapper" onClick={onShowDropdown}>
    <svg focusable="false" style={{width: 10, height: 8}}>
      <path d={open ? 'M0 6 L5 1 L10 6 Z' : 'M0 1 L5 6 L10 1 Z'} fill="#999999" />
    </svg>
  </div>
);

export default SelectizeLookingDropdownArrow;
